import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface InPlaySecondaryIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const InPlaySecondaryIcon = observer(
    'InPlaySecondaryIcon',
    ({ className, onClick }: InPlaySecondaryIconPropsType): JSX.Element => {
        return (
            <SvgElement
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                className={className}
                onClick={onClick}
            >
                <mask
                    id='a'
                    width='18'
                    height='22'
                    x='3'
                    y='1'
                    maskUnits='userSpaceOnUse'
                    style={{ maskType: 'alpha' }}
                >
                    <path
                        fill='fill'
                        d='M9 3.6v-2h6v2zm2 11h2v-6h-2zm1 8a8.65 8.65 0 0 1-3.488-.713A9.2 9.2 0 0 1 5.65 19.95a9.2 9.2 0 0 1-1.938-2.863A8.65 8.65 0 0 1 3 13.6q0-1.85.712-3.487A9.2 9.2 0 0 1 5.65 7.25a9.2 9.2 0 0 1 2.862-1.938A8.65 8.65 0 0 1 12 4.6a8.9 8.9 0 0 1 2.975.5q1.425.5 2.675 1.45l1.4-1.4 1.4 1.4-1.4 1.4a9.7 9.7 0 0 1 1.45 2.675q.5 1.425.5 2.975a8.65 8.65 0 0 1-.712 3.487 9.2 9.2 0 0 1-1.938 2.863 9.2 9.2 0 0 1-2.863 1.938A8.65 8.65 0 0 1 12 22.6'
                    />
                </mask>
                <g mask='url(#a)'>
                    <path
                        fill='fill'
                        fillOpacity='.64'
                        d='M0 0h24v24H0z'
                    />
                </g>
            </SvgElement>
        );
    }
);
